// AdvertisementCard.js
import React, { useEffect, useRef, useState } from "react";
import style from "./AdvertisementCard.module.css";
import { LuEye } from "react-icons/lu";
import { PiShareFat } from "react-icons/pi";
import {
  MdDownloadDone,
  MdOutlineShoppingCart,
} from "react-icons/md";
import { useSelector } from "react-redux";

const AdvertisementCard = ({
  adData,
  handleEditOpen,
}) => {
  const { theme } = useSelector((state) => state.theme);
  const chartRef = useRef(null);

  const data = {
    labels: ["January", "February", "March", "April", "May", "June", "July"],
    datasets: [
      {
        label: "Views",
        data: [35000, 22000, 80000, 15000, 56000, 11000, 40000],
        fill: false,
        backgroundColor: "rgba(10,255,10,0.4)",
        borderColor: "rgba(10,255,10,1)",
      },
      {
        label: "Orders",
        data: [32000, 32000, 10000, 95000, 19000, 11800, 10000],
        fill: false,
        backgroundColor: "rgba(255, 0, 0, 0.4)",
        borderColor: "rgba(255, 0, 0,1)",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        display: true,
      },
      y: {
        display: true,
      },
    },
  };
  return (
    <>
      <div
      onClick={() => handleEditOpen(adData)}
        className={`${
          theme === "light" ? "bg-secondaryColor" : "bg-darkThirsary"
        } ${style.advertisement_card}`}
        key={adData.id}
      >
        <div className="relative">
          <img
            className={style.advertisement_image}
            src={adData.image}
            alt={adData.title}
          />

      
        </div>
        <div className={style.ad_content}>
          <h2 className={`${
          theme === "light" ? "text-gray-900" : "text-gray-500"
        } ${style.ad_title}`}>{adData?.products?.name}</h2>
          <p className={style.ad_product}>Id: {adData.product}</p>
          <p className={style.ad_date}>
            Start Date: {new Date(adData.start_date).toLocaleDateString()}  
          </p>
          <p className={style.ad_date}>
            Exp Date: {new Date(adData.end_date).toLocaleDateString()}
          </p>
          <div className="flex justify-between px-2">
            <span className="flex flex-col items-center justify-center">
              <LuEye fontSize={"1.5rem"} />
              <span>{adData.advertise_views}</span>
            </span>
            <span className="flex flex-col items-center justify-center">
              <MdDownloadDone fontSize={"1.5rem"} />
              <span>{adData.ordered_by_advertise}</span>
            </span>
            <span className="flex flex-col items-center justify-center">
              <MdOutlineShoppingCart fontSize={"1.5rem"} />
              <span>{adData.addToCart_count}</span>
            </span>
            <span className="flex flex-col items-center justify-center">
              <PiShareFat fontSize={"1.5rem"} />
              <span>{adData.share}</span>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdvertisementCard;
